export default "__VITE_ASSET__DVPrGfcs__"